module.exports = __webpack_public_path__ + "static/img/aqzs14.a0c5f50d.jpg";